export var ErrorCode;
(function (ErrorCode) {
    // Auth
    ErrorCode["AUTH_TOKEN_MISSING"] = "AUTH_TOKEN_MISSING";
    ErrorCode["AUTH_TOKEN_INVALID"] = "AUTH_TOKEN_INVALID";
    ErrorCode["AUTH_DOMAIN_RESTRICTED"] = "AUTH_DOMAIN_RESTRICTED";
    ErrorCode["AUTH_PERMISSION_DENIED"] = "AUTH_PERMISSION_DENIED";
    // API
    ErrorCode["API_HANDLER_NOT_FOUND"] = "API_HANDLER_NOT_FOUND";
    ErrorCode["API_INVALID_INPUT"] = "API_INVALID_INPUT";
    ErrorCode["API_INTERNAL_ERROR"] = "API_INTERNAL_ERROR";
    // Ticket
    ErrorCode["TICKET_NOT_FOUND"] = "TICKET_NOT_FOUND";
    ErrorCode["TICKET_ACCESS_DENIED"] = "TICKET_ACCESS_DENIED";
    ErrorCode["TICKET_INVALID_STATUS"] = "TICKET_INVALID_STATUS";
    // User
    ErrorCode["USER_NOT_FOUND"] = "USER_NOT_FOUND";
    // Conversation
    ErrorCode["CONVERSATION_NOT_FOUND"] = "CONVERSATION_NOT_FOUND";
    // Agent
    ErrorCode["AGENT_PROCESSING_FAILED"] = "AGENT_PROCESSING_FAILED";
    // GitHub
    ErrorCode["GITHUB_API_ERROR"] = "GITHUB_API_ERROR";
    ErrorCode["GITHUB_ISSUE_CREATION_FAILED"] = "GITHUB_ISSUE_CREATION_FAILED";
})(ErrorCode || (ErrorCode = {}));
//# sourceMappingURL=api.js.map